<template>
  <div class="login">
    <div class="left-box">
      <el-image :src="logoImage" class="logo-image"></el-image>
      <loginAccount></loginAccount>
    </div>
    <div class="right-box"></div>
  </div>
</template>

<script>
import loginAccount from "./loginAccount.vue";
export default {
  components: {
    loginAccount,
  },
  data() {
    return {
      logoImage: require("@/assets/imgs/logo.jpg"),};
  },

  created() {
    localStorage.clear();
    sessionStorage.clear();
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  display: flex;
  .left-box {
    width: 30%;
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logo-image{
      width: 2rem;
      height: 2rem;
      position: relative;
      top: -1.5rem;
    }
  }
  .right-box {
    width: 70%;
    height: 100%;
    background: url("~@/assets/imgs/login_bg.png") no-repeat;
    background-size: cover;
  }
}
</style>
